define.alias("shared/components/shared/asset-upload", "settings/components/shared/asset-upload");